import { tryCatch } from '@thalesrc/js-utils';

import HSApi from '../HSApi';
import { GetDepartmentsResult } from './get-departments.result';

export async function getDepartments(): Promise<GetDepartmentsResult[]> {
  const [error, res] = await tryCatch(HSApi.get<GetDepartmentsResult[]>(`/firms/department-definitions`));

  if (error) {
    // tslint:disable-next-line:no-console
    console.error(error);

    throw error;
  }

  return res.data;
}
